export const DISCOUNT = {
  MILITARY: 'military_discount',
  STUDENT: 'student_discount',
} as const
